import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = {
  class: "navbar navbar-vertical navbar-expand-lg",
  "data-bs-theme": "dark"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = {
  class: "collapse navbar-collapse",
  id: "sidebar-menu"
}
const _hoisted_4 = { class: "navbar-nav pt-lg-3" }

import {useRoute} from "vue-router"
import router from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const route = useRoute()

const logout = () => {
  localStorage.removeItem("token")
  router.push("/login")
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createStaticVNode("<button class=\"navbar-toggler\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#sidebar-menu\" aria-controls=\"sidebar-menu\" aria-expanded=\"false\" aria-label=\"Toggle navigation\"><span class=\"navbar-toggler-icon\"></span></button><h1 class=\"navbar-brand navbar-brand-autodark\"><a href=\".\"><img src=\"" + _imports_0 + "\" width=\"110\" height=\"32\" alt=\"Tabler\" class=\"navbar-brand-image\"></a></h1><div class=\"navbar-nav flex-row d-lg-none\"><div class=\"nav-item d-none d-lg-flex me-3\"><div class=\"btn-list\"><a href=\"https://github.com/tabler/tabler\" class=\"btn\" target=\"_blank\" rel=\"noreferrer\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"icon\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5\"></path></svg> Source code </a><a href=\"https://github.com/sponsors/codecalm\" class=\"btn\" target=\"_blank\" rel=\"noreferrer\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"icon text-pink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572\"></path></svg> Sponsor </a></div></div><div class=\"d-none d-lg-flex\"><a href=\"?theme=dark\" class=\"nav-link px-0 hide-theme-dark\" data-bs-toggle=\"tooltip\" data-bs-placement=\"bottom\" aria-label=\"Enable dark mode\" data-bs-original-title=\"Enable dark mode\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"icon\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z\"></path></svg></a><a href=\"?theme=light\" class=\"nav-link px-0 hide-theme-light\" data-bs-toggle=\"tooltip\" data-bs-placement=\"bottom\" aria-label=\"Enable light mode\" data-bs-original-title=\"Enable light mode\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"icon\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0\"></path><path d=\"M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7\"></path></svg></a><div class=\"nav-item dropdown d-none d-md-flex me-3\"><a href=\"#\" class=\"nav-link px-0\" data-bs-toggle=\"dropdown\" tabindex=\"-1\" aria-label=\"Show notifications\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"icon\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6\"></path><path d=\"M9 17v1a3 3 0 0 0 6 0v-1\"></path></svg><span class=\"badge bg-red\"></span></a><div class=\"dropdown-menu dropdown-menu-arrow dropdown-menu-end dropdown-menu-card\"><div class=\"card\"><div class=\"card-header\"><h3 class=\"card-title\">Last updates</h3></div><div class=\"list-group list-group-flush list-group-hoverable\"><div class=\"list-group-item\"><div class=\"row align-items-center\"><div class=\"col-auto\"><span class=\"status-dot status-dot-animated bg-red d-block\"></span></div><div class=\"col text-truncate\"><a href=\"#\" class=\"text-body d-block\">Example 1</a><div class=\"d-block text-secondary text-truncate mt-n1\"> Change deprecated html tags to text decoration classes (#29604) </div></div><div class=\"col-auto\"><a href=\"#\" class=\"list-group-item-actions\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"icon text-muted\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z\"></path></svg></a></div></div></div><div class=\"list-group-item\"><div class=\"row align-items-center\"><div class=\"col-auto\"><span class=\"status-dot d-block\"></span></div><div class=\"col text-truncate\"><a href=\"#\" class=\"text-body d-block\">Example 2</a><div class=\"d-block text-secondary text-truncate mt-n1\"> justify-content:between ⇒ justify-content:space-between (#29734) </div></div><div class=\"col-auto\"><a href=\"#\" class=\"list-group-item-actions show\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"icon text-yellow\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z\"></path></svg></a></div></div></div><div class=\"list-group-item\"><div class=\"row align-items-center\"><div class=\"col-auto\"><span class=\"status-dot d-block\"></span></div><div class=\"col text-truncate\"><a href=\"#\" class=\"text-body d-block\">Example 3</a><div class=\"d-block text-secondary text-truncate mt-n1\"> Update change-version.js (#29736) </div></div><div class=\"col-auto\"><a href=\"#\" class=\"list-group-item-actions\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"icon text-muted\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z\"></path></svg></a></div></div></div><div class=\"list-group-item\"><div class=\"row align-items-center\"><div class=\"col-auto\"><span class=\"status-dot status-dot-animated bg-green d-block\"></span></div><div class=\"col text-truncate\"><a href=\"#\" class=\"text-body d-block\">Example 4</a><div class=\"d-block text-secondary text-truncate mt-n1\"> Regenerate package-lock.json (#29730) </div></div><div class=\"col-auto\"><a href=\"#\" class=\"list-group-item-actions\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"icon text-muted\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z\"></path></svg></a></div></div></div></div></div></div></div></div><div class=\"nav-item dropdown\"><a href=\"#\" class=\"nav-link d-flex lh-1 text-reset p-0\" data-bs-toggle=\"dropdown\" aria-label=\"Open user menu\"><span class=\"avatar avatar-sm\" style=\"background-image:url(./static/avatars/000m.jpg);\"></span><div class=\"d-none d-xl-block ps-2\"><div>Paweł Kuna</div><div class=\"mt-1 small text-secondary\">UI Designer</div></div></a><div class=\"dropdown-menu dropdown-menu-end dropdown-menu-arrow\"><a href=\"#\" class=\"dropdown-item\">Status</a><a href=\"./profile.html\" class=\"dropdown-item\">Profile</a><a href=\"#\" class=\"dropdown-item\">Feedback</a><div class=\"dropdown-divider\"></div><a href=\"./settings.html\" class=\"dropdown-item\">Settings</a><a href=\"./sign-in.html\" class=\"dropdown-item\">Logout</a></div></div></div>", 3)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", {
            class: _normalizeClass({'nav-item': 1, active: _unref(route).fullPath === '/'})
          }, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("span", { class: "nav-link-icon d-md-none d-lg-inline-block" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "icon",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    "stroke-width": "2",
                    stroke: "currentColor",
                    fill: "none",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", {
                      stroke: "none",
                      d: "M0 0h24v24H0z",
                      fill: "none"
                    }),
                    _createElementVNode("path", { d: "M5 12l-2 0l9 -9l9 9l-2 0" }),
                    _createElementVNode("path", { d: "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" }),
                    _createElementVNode("path", { d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" })
                  ])
                ], -1),
                _createElementVNode("span", { class: "nav-link-title" }, " Home ", -1)
              ])),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({'nav-item': 1, active: _unref(route).fullPath.startsWith('/dashboard-lini')})
          }, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/dashboard-lini"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("span", { class: "nav-link-icon d-md-none d-lg-inline-block" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "icon",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    "stroke-width": "2",
                    stroke: "currentColor",
                    fill: "none",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", {
                      stroke: "none",
                      d: "M0 0h24v24H0z",
                      fill: "none"
                    }),
                    _createElementVNode("path", { d: "M5 12l-2 0l9 -9l9 9l-2 0" }),
                    _createElementVNode("path", { d: "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" }),
                    _createElementVNode("path", { d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" })
                  ])
                ], -1),
                _createElementVNode("span", { class: "nav-link-title" }, " Dashboard Lini ", -1)
              ])),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({'nav-item': 1, active: _unref(route).fullPath.startsWith('/action-plant')})
          }, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/action-plant"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("span", { class: "nav-link-icon d-md-none d-lg-inline-block" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: "icon icon-tabler icons-tabler-outline icon-tabler-brand-vite"
                  }, [
                    _createElementVNode("path", {
                      stroke: "none",
                      d: "M0 0h24v24H0z",
                      fill: "none"
                    }),
                    _createElementVNode("path", { d: "M10 4.5l6 -1.5l-2 6.5l2 -.5l-4 7v-5l-3 1z" }),
                    _createElementVNode("path", { d: "M15 6.5l7 -1.5l-10 17l-10 -17l7.741 1.5" })
                  ])
                ], -1),
                _createElementVNode("span", { class: "nav-link-title" }, " SPV Action Plant ", -1)
              ])),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({'nav-item': 1, active: _unref(route).fullPath.startsWith('/oee-monitoring')})
          }, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/oee-monitoring"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("span", { class: "nav-link-icon d-md-none d-lg-inline-block" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: "icon icon-tabler icons-tabler-outline icon-tabler-device-desktop"
                  }, [
                    _createElementVNode("path", {
                      stroke: "none",
                      d: "M0 0h24v24H0z",
                      fill: "none"
                    }),
                    _createElementVNode("path", { d: "M3 5a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10z" }),
                    _createElementVNode("path", { d: "M7 20h10" }),
                    _createElementVNode("path", { d: "M9 16v4" }),
                    _createElementVNode("path", { d: "M15 16v4" })
                  ])
                ], -1),
                _createElementVNode("span", { class: "nav-link-title" }, " OEE Monitoring ", -1)
              ])),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({'nav-item': 1, active: _unref(route).fullPath.startsWith('/downtime-control')})
          }, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/downtime-control"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("span", { class: "nav-link-icon d-md-none d-lg-inline-block" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: "icon icon-tabler icons-tabler-outline icon-tabler-timeline-event-exclamation"
                  }, [
                    _createElementVNode("path", {
                      stroke: "none",
                      d: "M0 0h24v24H0z",
                      fill: "none"
                    }),
                    _createElementVNode("path", { d: "M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" }),
                    _createElementVNode("path", { d: "M10 20h-6" }),
                    _createElementVNode("path", { d: "M14 20h6" }),
                    _createElementVNode("path", { d: "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z" }),
                    _createElementVNode("path", { d: "M12 6v2" }),
                    _createElementVNode("path", { d: "M12 11v.01" })
                  ])
                ], -1),
                _createElementVNode("span", { class: "nav-link-title" }, " Downtime Control ", -1)
              ])),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({'nav-item': 1, active: _unref(route).fullPath.startsWith('/action-plan-monitoring')})
          }, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/action-plan-monitoring"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createElementVNode("span", { class: "nav-link-icon d-md-none d-lg-inline-block" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: "icon icon-tabler icons-tabler-outline icon-tabler-calendar"
                  }, [
                    _createElementVNode("path", {
                      stroke: "none",
                      d: "M0 0h24v24H0z",
                      fill: "none"
                    }),
                    _createElementVNode("path", { d: "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" }),
                    _createElementVNode("path", { d: "M16 3v4" }),
                    _createElementVNode("path", { d: "M8 3v4" }),
                    _createElementVNode("path", { d: "M4 11h16" }),
                    _createElementVNode("path", { d: "M11 15h1" }),
                    _createElementVNode("path", { d: "M12 15v3" })
                  ])
                ], -1),
                _createElementVNode("span", { class: "nav-link-title" }, " Action Plan Monitoring ", -1)
              ])),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({'nav-item': 1, active: _unref(route).fullPath.startsWith('/production-status')})
          }, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/production-status"
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createElementVNode("span", { class: "nav-link-icon d-md-none d-lg-inline-block" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: "icon icon-tabler icons-tabler-outline icon-tabler-building-factory-2"
                  }, [
                    _createElementVNode("path", {
                      stroke: "none",
                      d: "M0 0h24v24H0z",
                      fill: "none"
                    }),
                    _createElementVNode("path", { d: "M3 21h18" }),
                    _createElementVNode("path", { d: "M5 21v-12l5 4v-4l5 4h4" }),
                    _createElementVNode("path", { d: "M19 21v-8l-1.436 -9.574a.5 .5 0 0 0 -.495 -.426h-1.145a.5 .5 0 0 0 -.494 .418l-1.43 8.582" }),
                    _createElementVNode("path", { d: "M9 17h1" }),
                    _createElementVNode("path", { d: "M14 17h1" })
                  ])
                ], -1),
                _createElementVNode("span", { class: "nav-link-title" }, " Production Status ", -1)
              ])),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({'nav-item': 1, active: _unref(route).fullPath.startsWith('/quality-performance')})
          }, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/quality-performance"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createElementVNode("span", { class: "nav-link-icon d-md-none d-lg-inline-block" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: "icon icon-tabler icons-tabler-outline icon-tabler-augmented-reality"
                  }, [
                    _createElementVNode("path", {
                      stroke: "none",
                      d: "M0 0h24v24H0z",
                      fill: "none"
                    }),
                    _createElementVNode("path", { d: "M4 8v-2a2 2 0 0 1 2 -2h2" }),
                    _createElementVNode("path", { d: "M4 16v2a2 2 0 0 0 2 2h2" }),
                    _createElementVNode("path", { d: "M16 4h2a2 2 0 0 1 2 2v2" }),
                    _createElementVNode("path", { d: "M16 20h2a2 2 0 0 0 2 -2v-2" }),
                    _createElementVNode("path", { d: "M12 12.5l4 -2.5" }),
                    _createElementVNode("path", { d: "M8 10l4 2.5v4.5l4 -2.5v-4.5l-4 -2.5z" }),
                    _createElementVNode("path", { d: "M8 10v4.5l4 2.5" })
                  ])
                ], -1),
                _createElementVNode("span", { class: "nav-link-title" }, " Quality Performance ", -1)
              ])),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({'nav-item': 1, active: _unref(route).fullPath.startsWith('/melting-report')})
          }, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/melting-report"
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createElementVNode("span", { class: "nav-link-icon d-md-none d-lg-inline-block" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: "icon icon-tabler icons-tabler-outline icon-tabler-chart-infographic"
                  }, [
                    _createElementVNode("path", {
                      stroke: "none",
                      d: "M0 0h24v24H0z",
                      fill: "none"
                    }),
                    _createElementVNode("path", { d: "M7 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" }),
                    _createElementVNode("path", { d: "M7 3v4h4" }),
                    _createElementVNode("path", { d: "M9 17l0 4" }),
                    _createElementVNode("path", { d: "M17 14l0 7" }),
                    _createElementVNode("path", { d: "M13 13l0 8" }),
                    _createElementVNode("path", { d: "M21 12l0 9" })
                  ])
                ], -1),
                _createElementVNode("span", { class: "nav-link-title" }, " Melting Report ", -1)
              ])),
              _: 1
            })
          ], 2),
          _createElementVNode("li", { class: "nav-item" }, [
            _createElementVNode("a", {
              href: "javascript:;",
              class: "nav-link",
              onClick: logout
            }, _cache[9] || (_cache[9] = [
              _createStaticVNode("<span class=\"nav-link-icon d-md-none d-lg-inline-block\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"icon icon-tabler icons-tabler-outline icon-tabler-logout\"><path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2\"></path><path d=\"M9 12h12l-3 -3\"></path><path d=\"M18 15l3 -3\"></path></svg></span><span class=\"nav-link-title\"> Logout </span>", 2)
            ]))
          ])
        ])
      ])
    ])
  ]))
}
}

})